import Table from 'components/custom/TableV2/Table'

import React, { Component } from 'react'
import { IconButton } from 'react-toolbox/lib/button'
import CSSModules from 'helpers/CSSModulesUtil'
import { compose } from 'recompose'
import cn from 'classnames'
import { ENV } from 'config.js'
import { connect } from 'react-redux'
import {
  addTableFilter,
  addTableSort
} from './actions'
import {
  tableFilterSelector,
  tableSortSelector
} from './selectors'

import styles from './styles.scss'

const mapStateToProps = state => {
  return {
    tableFilter: tableFilterSelector(state),
    tableSort: tableSortSelector(state)
  }
}

const mapDispatchToProps = dispatch => {
  return {
    addTableFilter: (key, val) => dispatch(addTableFilter(key, val)),
    addTableSort: (key, val) => dispatch(addTableSort(key, val))
  }
} 

class TableWrapper extends Component {

  getUrl = (bugId) => {
    const prefix = ENV === 'production' ? 'nvbugswb' : 'stbugswb'
    return `https://${prefix}.nvidia.com/NvBugs5/HWBug.aspx?bugid=${bugId}&cmtNo=`
  }

  onRowClick = (source, row) => {
    var win = window.open(this.getUrl(source[row].bugId), '_blank');
    win.focus();
  }

  onMenuSubmit = (filterObj) => {
    const { addTableFilter, addTableSort } = this.props
    Object.keys(filterObj).forEach(key => {
      const filter = filterObj[key].filter
      const sort = filterObj[key].sort
      filter && addTableFilter(key, filter)
      sort && addTableSort(key, sort)
    })
  }

  render(){
    const { source, sourceVal, tableHeadContent, tableFilter, tableSort } = this.props
    return (
      <Table
        className={styles.tablef}
        key={new Date().getTime()}
        selectable={false}
        source={source}
        sourceVal={sourceVal}
        tableHeadContent={tableHeadContent}
        onMenuSubmit={this.onMenuSubmit}
        tableFilter={tableFilter}
        tableSort={tableSort}
        onRowClick={this.onRowClick.bind(this, source)}
      />
    )
  }
}
const withConnect = connect(mapStateToProps, mapDispatchToProps)
const withStyle = CSSModules(styles)

const enhance = compose(
  withConnect,
  withStyle
)

export default enhance(TableWrapper)